import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["BlogList"] */ "/app/src/components/new/Blogs/BlogList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/new/NewsletterSubscribe/NewsletterSubscribe.tsx");
